import { Button, CircularProgress } from "@mui/material";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import { useTranslation } from "react-i18next";
import { useCancelCalculationMutation } from "src/hooks/results";

interface Props {
  caseId: string | number;
}

export function CancelCalculationButton({ caseId }: Props) {
  const { t } = useTranslation();
  const cancelCalculation = useCancelCalculationMutation(caseId);

  return (
    <Button
      color="warning"
      variant="contained"
      disabled={cancelCalculation.isLoading || cancelCalculation.isSuccess}
      startIcon={
        cancelCalculation.isLoading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <StopCircleOutlinedIcon />
        )
      }
      onClick={() => cancelCalculation.mutate()}
    >
      {t("label.cancelCalculation", "Cancel calculation")}
    </Button>
  );
}
